module.exports = __webpack_public_path__ + "img/issue-icon3.e9f635f.png";